/**
 * Gets the repositories of the user from Github
 */

import { fork } from 'redux-saga/effects';
import checkoutWatcher from './sagas/CheckoutSaga';

export default function* homePageSaga() {
  yield [fork(checkoutWatcher)];
}
